var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license-explanation-tooltip padding-small"},[_c('h5',{staticClass:"b-header"},[_vm._v("License CC "+_vm._s(_vm.license.toUpperCase()))]),_vm._v(" "),_c('license-explanations',{attrs:{"license":_vm.license}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }